function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M23.75 0H6.25A6.251 6.251 0 000 6.25v17.5A6.251 6.251 0 006.25 30h17.5A6.25 6.25 0 0030 23.75V6.25A6.25 6.25 0 0023.75 0zM10 23.75H6.25V10H10zM8.125 8.415a2.205 2.205 0 112.188-2.205 2.2 2.2 0 01-2.188 2.205zM25 23.75h-3.75v-7.005c0-4.21-5-3.891-5 0v7.005H12.5V10h3.75v2.206C17.995 8.974 25 8.735 25 15.3z",
  fill: "#213854"
});

var SvgLinkedinIcon = function SvgLinkedinIcon(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 30 30"
  }, props), _ref);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMCAzMCI+PGRlZnM+PHN0eWxlPi5he2ZpbGw6IzIxMzg1NDt9PC9zdHlsZT48L2RlZnM+PHBhdGggY2xhc3M9ImEiIGQ9Ik0yMy43NSwwSDYuMjVBNi4yNTEsNi4yNTEsMCwwLDAsMCw2LjI1djE3LjVBNi4yNTEsNi4yNTEsMCwwLDAsNi4yNSwzMGgxNy41QTYuMjUsNi4yNSwwLDAsMCwzMCwyMy43NVY2LjI1QTYuMjUsNi4yNSwwLDAsMCwyMy43NSwwWk0xMCwyMy43NUg2LjI1VjEwSDEwWk04LjEyNSw4LjQxNUEyLjIwNSwyLjIwNSwwLDEsMSwxMC4zMTMsNi4yMSwyLjIsMi4yLDAsMCwxLDguMTI1LDguNDE1Wk0yNSwyMy43NUgyMS4yNVYxNi43NDVjMC00LjIxLTUtMy44OTEtNSwwVjIzLjc1SDEyLjVWMTBoMy43NXYyLjIwNkMxNy45OTUsOC45NzQsMjUsOC43MzUsMjUsMTUuM1oiLz48L3N2Zz4=";
export { SvgLinkedinIcon as ReactComponent };